<template>
  <div class="payment-success-page">
    <div class="payment-success-container">
      <div class="payment-success-header-section">
        <div class="icon-section">
          <i class="far fa-check-circle" />
        </div>
        <div class="title-text">ท่านทำรายการสำเร็จแล้ว</div>
      </div>

      <div class="success-description-text" v-if="type === 'bill-payment'">
        ระบบได้ทำการจัดส่ง Bill payment ไปยังอีเมล
        <span class="highlight-text"> {{ insuredEmail }}</span> ของผู้ชำระเบี้ยประกันภัย และอีเมล
        <span class="highlight-text"> {{ staffEmail }}</span> ของพนักงานเรียบร้อยแล้ว
      </div>

      <div class="payment-success-thankyou-container">
        ประกันภัยไทยวิวัฒน์ จำกัด (มหาชน) ขอขอบคุณที่ท่านให้ความไว้ใจในการทำประกันภัยในโครงการ
        ประกันภัยสุขภาพและอุบัติเหตุส่วนบุคคล ttb health care plus (Extra/Classic)
      </div>

      <div class="application-information-container">
        <div class="application-information">
          <div class="information-name">เลขที่ใบคำขอ :</div>
          <div class="information-value">{{ application_id }}</div>
        </div>
        <div class="application-information">
          <div class="information-name">เลขที่อ้างอิง :</div>
          <div class="information-value">{{ pvApplicationNumber }}</div>
        </div>
        <div class="application-information">
          <div class="information-name">ผู้เอาประกันภัย :</div>
          <div class="information-value">{{ insuredName }}</div>
        </div>
        <div class="application-information">
          <div class="information-name">เบี้ยประกันภัย :</div>
          <div class="information-value">{{ insurancePrice | formatNumber }}</div>
        </div>
        <div class="application-information">
          <div class="information-name">ช่องทางการชำระเงิน :</div>
          <div class="information-value">{{ paymentMethod }}</div>
        </div>
        <div class="application-information" v-if="type === 'direct-debit' && bankAccountNumber">
          <div class="information-name">เลขที่บัญชี :</div>
          <div class="information-value">{{ bankAccountNumber }}</div>
        </div>
        <div class="application-information">
          <div class="information-name">พนักงานขาย :</div>
          <div class="information-value">{{ staffName }}</div>
        </div>
      </div>

      <div class="payment-success-footer-container">
        <span v-if="isDeliveryMethodEmail">
          บริษัทจะจัดส่งกรมธรรม์ให้กับท่านทางอีเมล
          <span class="highlight-text">{{ insuredEmail }}</span>
          หากท่านยังไม่ได้รับอีเมลกรมธรรม์ภายใน 24 ชั่วโมง
        </span>
        <span v-else>
          บริษัทจะจัดส่งกรมธรรม์ให้กับท่านทางไปรษณีย์ตามที่อยู่ที่ท่านได้ระบุไว้
          หากยังไม่ได้รับกรมธรรม์ ภายใน 7 วัน
        </span>
        กรุณาติดต่อมาที่เบอร์โทร 1231 กด 3 หรือส่งอีเมลแจ้งมาที่ support_tmbhcp@thaivivat.co.th
      </div>

      <div class="back-homepage-btn-container">
        <Button class="back-homepage-btn" @click.native="backHomepage">กลับหน้าหลัก</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { createHelpers } from 'vuex-map-fields'
import _ from 'lodash'

import Button from '@/components/Button'
import { log } from '@chenfengyuan/vue-qrcode'

const { mapFields: mapApplicationFields } = createHelpers({
  getterType: 'getApplicationFields',
  mutationType: 'updateApplicationFields',
})

const { mapFields: mapPaymentFields } = createHelpers({
  getterType: 'getPaymentFields',
  mutationType: 'updatePaymentFields',
})

export default {
  name: 'PaymentSuccess',
  data: () => ({
    insuredEmail: '',
    staffEmail: '',
    bankAccountNumber: '',
    pvApplicationNumber: '',
  }),
  props: ['type', 'application_id'],
  components: {
    Button,
  },
  watch: {
    applicationInformation: {
      handler(data) {
        const paymentId = _.get(data, 'payment.id')

        this.insuredEmail = _.get(data, 'insuredPerson.email') || '-'
        this.staffEmail = _.get(data, 'broker.email') || '-'
        this.pvApplicationNumber = _.get(data, 'application.pvApplicationNumber', '')

        if (paymentId === 2) {
          this.getPaymentInformation(this.application_id)
        }
      },
      deep: true,
    },
    paymentInformation(data) {
      if (data) {
        const accountNumber = _.get(data, 'detail.accountNumber', null)

        this.bankAccountNumber = accountNumber.substring(4)
      }
    },
  },
  mounted() {
    this.getApplicationInformation(this.application_id)
    this.submitPolicyProcessComplete(this.application_id)
  },
  computed: {
    ...mapApplicationFields({
      applicationInformation: 'data.applicationInformation',
    }),
    ...mapPaymentFields({
      paymentInformation: 'paymentInformation.data',
    }),
    insuredName() {
      const insuredNamePrefix = _.get(this.applicationInformation, 'insuredPerson.title.name') || ''
      const insuredFirstname = _.get(this.applicationInformation, 'insuredPerson.firstname') || ''
      const insuredLastname = _.get(this.applicationInformation, 'insuredPerson.lastname') || ''

      return `${insuredNamePrefix}${insuredFirstname} ${insuredLastname}`.trim()
    },
    insurancePrice() {
      const isCombinePayment = _.get(
        this.applicationInformation,
        'familyQuotation.isCombinePayment',
        false,
      )

      if (isCombinePayment) {
        return _.get(this.applicationInformation, 'familyQuotation.pricingSum', 0)
      }

      return _.get(this.applicationInformation, 'pricing.netPremium', 0)
    },
    paymentMethod() {
      return _.get(this.applicationInformation, 'payment.paymentType')
    },
    staffName() {
      const brokerNamePrefix = _.get(this.applicationInformation, 'broker.title') || ''
      const brokerFirstname = _.get(this.applicationInformation, 'broker.firstname') || ''
      const brokerLastname = _.get(this.applicationInformation, 'broker.lastname') || ''

      return `${brokerNamePrefix}${brokerFirstname} ${brokerLastname}`.trim()
    },
    isDeliveryMethodEmail() {
      return _.get(this.applicationInformation, 'application.deliveryMethod') === 'email'
    },
  },
  methods: {
    ...mapActions([
      'getApplicationInformation',
      'getPaymentInformation',
      'submitPolicyProcessComplete',
    ]),
    backHomepage() {
      const familyId = _.get(this.applicationInformation, 'familyQuotation.familyId', null)

      if (familyId) {
        return this.$router.push(`/insurance_family/${familyId}`)
      }

      return this.$router.push('/home')
    },
  },
}
</script>

<style lang="scss">
.payment-success-page {
  padding-top: 48px;

  .payment-success-container {
    background-color: #fff;
    margin: 0 auto;
    padding: 32px;
    width: 90%;

    .payment-success-header-section {
      text-align: center;

      .icon-section {
        color: #27ae60;
        font-size: 100px;
        margin-bottom: 16px;
      }

      .title-text {
        font-family: 'psl_kanda_extraregular';
        font-size: 24px;
        line-height: 28px;
        margin-bottom: 16px;
      }
    }

    .success-description-text,
    .payment-success-thankyou-container,
    .application-information-container,
    .payment-success-footer-container {
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 16px;
      text-indent: 32px;
    }

    .application-information-container {
      margin: 0 auto;
      text-indent: unset;
      width: 80%;

      .application-information {
        display: grid;
        grid-gap: 20px;
        grid-template-columns: 1fr 2fr;
        margin-bottom: 16px;

        .information-value {
          font-family: 'psl_kanda_extraregular';
          text-align: center;
        }
      }
    }

    .highlight-text {
      color: #27ae60;
      font-family: 'psl_kanda_extraregular';
    }

    .back-homepage-btn-container {
      margin-top: 24px;
      text-align: center;
    }
  }
}
</style>
